import { ConsumablesMasterThemeModeConfig } from './types';

const light: ConsumablesMasterThemeModeConfig = {
  consumablesMaster: {},
};

export default light;
